<template>
  <div class="Tag"
    :class="classes">

    <div class="Tag-icon"
      v-if="icon">
      <icon :name="icon" />
    </div>

    <div class="Tag-label"
      v-if="label">
      {{ label }}
    </div>

    <div class="Tag-meta"
      v-if="meta">
      {{ meta }}
    </div>

  </div>
</template>

<script>
/**
 * Tag
 * - For displaying [icon | label | meta] tags
 */
export default {
  name: 'Tag',

  props: {
    icon: {
      type: String
    },

    label: {
      type: [String, Number]
    },

    meta: {
      type: [String, Number]
    },

    large: {
      type: Boolean,
      default: false
    },

    highlighted: {
      type: Boolean,
      default: false
    },

    light: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    /**
     * Clases for the main element
     * @return {Object}
     */
    classes () {
      return {
        'Tag--isLarge': this.large,
        'Tag--isHighlighted': this.highlighted,
        'Tag--isLight': this.light
      }
    }
  }
}
</script>

<style>
@import 'properties';

.Tag {
  display: inline-flex;
  align-items: center;

  padding: 0 12px;
  height: 30px;

  font-size: 11px;
  line-height: 1;
  color: var(--c-white);
  -webkit-font-smoothing: antialiased;

  background-color: var(--c-black-075);
  border: 1px solid var(--c-grey-lt-075);
  border-radius: var(--radius);
  user-select: none;
}

.Tag--isLarge {

  @media (min-width: 400px) {
    height: 42px;
    font-size: 15px;
  }
}

.Tag--isLight {
  background-color: var(--c-white);
  border-color: var(--c-grey-xlt2);
  color: var(--c-black);
}

.Tag--isHighlighted {
  background-color: var(--c-blue);
  border-color: transparent;
  color: var(--c-white);
}

.Tag > * + * {
  margin-left: 6px;
}

.Tag--isLarge > * + * {

  @media (min-width: 400px) {
    margin-left: 12px;
  }
}

.Tag-icon {

}

.Tag-icon svg {
  fill: var(--c-white) !important;
}

.Tag--isLarge .Tag-icon .Icon {

  @media (min-width: 400px) {
    width: 16px !important;
    height: 16px !important;
  }
}

.Tag--isLight .Tag-icon svg {
  fill: var(--c-black) !important;
}

.Tag--isHighlighted.Tag--isLight .Tag-icon svg {
  fill: var(--c-white) !important;
}

.Tag-label {

}

.Tag-meta {

}

.Tag--isLarge .Tag-meta {
  display: none;
  color: var(--c-grey-lt);

  @media (min-width: 400px) {
    display: block;
  }
}

.Tag--isHighlighted .Tag-meta {
  color: var(--c-black);
}
</style>



// WEBPACK FOOTER //
// Tag.vue?495a8697